// extracted by mini-css-extract-plugin
export var red = "main-module--red--1eaf3";
export var small = "main-module--small--a8fd8";
export var subtitle = "main-module--subtitle--fdb6f";
export var title = "main-module--title--d2eb8";
export var violet = "main-module--violet--77032";